import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { CustomValidators } from 'ng2-validation';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { AccountsService, TranslationService, PortalType } from 'src/app/core';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Router } from '@angular/router';

@UntilDestroy()
@Component({
  selector: 'app-forgot-password-form',
  templateUrl: './forgot-password-form.component.html',
  styleUrls: ['./forgot-password-form.component.less'],
})
export class ForgotPasswordFormComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  isSubmitting = false;

  constructor(
    private translationService: TranslationService,
    private notificationService: NotificationService,
    private fb: FormBuilder,
    private accountsService: AccountsService,
    private router: Router
  ) {
    this.forgotPasswordForm = this.fb.group(this.forgotPasswordFormModel());
  }

  ngOnInit(): void {}

  forgotPasswordFormModel(): any {
    return {
      email: [
        '',
        [Validators.required, Validators.maxLength(40), CustomValidators.email],
      ],
    };
  }

  submitForm(): void {
    this.isSubmitting = true;
    this.accountsService
      .resetPasswordRequest({
        email: this.forgotPasswordForm.get('email').value,
        locale: this.translationService.getCurrentOxioLocaleCode(),
        portalType: PortalType.PORTAL_V3,
      })
      .pipe(untilDestroyed(this))
      .subscribe(
        (res) => {
          this.isSubmitting = false;
          this.notificationService.success(
            'PAGE.AUTH.FORGOT_PASSWORD.SUCCESS_TITLE',
            'PAGE.AUTH.FORGOT_PASSWORD.SUCCESS_MESSAGE',
            this.forgotPasswordForm.get('email').value
          );
          setTimeout(() => {
            this.router.navigateByUrl('/login');
          }, 15000);
        },
        (error) => {
          this.isSubmitting = false;
          this.notificationService.errorHandler(error);
        }
      );
  }
}
